export default __webpack_public_path__ + "static/domain-tab-2-db7102438311edf010a7ff971ad49903.png";